import { IMachineDefault } from '../types';
export const IMachine: IMachineDefault = {
  IDLE: 'IDLE',
  START: 'START',
  FINISH: 'FINISH',
  PREPARE_DATA: 'PREPARE_DATA',
};

export const HeadersType = {
  smilesToken: 'x-smiles-token',
  recaptcha: 'x-recaptcha',
  xApiKey: 'x-api-key',
  clientOS: 'x-smiles-client-os',
};

export const CORE_VERSION = 'coreVersion';

export const MOCK_ENDPOINT = {
  endpoint: 'https://mock.main.local/',
  environment: 'development',
  type: 'Smiles',
};

export const STATUS_SERVICE_SUCCESS = [[200, 201, 203, 204]];
